import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';
import { FastFilter } from '@vlabs/uikit';

// eslint-disable-next-line import-x/no-namespace
import * as Popovers from './popovers';

const withBottomPopover = withPopover({ placement: 'bottom-start' });
const withFastBottomPopover = withBottomPopover(FastFilter);

export const CreationDateFilterWithBottomPopover = withFastBottomPopover(Popovers.CreationDateFilterPopover);
export const UpdateDateFilterWithBottomPopover = withFastBottomPopover(Popovers.UpdateDateFilterPopover);
export const NameFilterWithBottomPopover = withFastBottomPopover(Popovers.NameFilterPopover);
